// /* eslint func-names: off */
// ;(function () {
//   if (window.subscriptionWidgetInitialized) {
//     /* eslint no-console: off */
//     console.log('Subscription widget already initialized')

//     return
//   }

//   window.subscriptionWidgetInitialized = true
  
//   window.handleFrequencyChange = function(event) {
//     const selectedOption = event.target.selectedOptions[0];
//     const sellingPlanId = selectedOption.value;
//     const variant = event.target.closest('[id^="subscription-variant--"]');
    
//     // Update the hidden selling plan select
//     const hiddenSelect = variant.querySelector('select[name="selling_plan"]');
//     if (hiddenSelect) {
//       hiddenSelect.value = sellingPlanId;
      
//       // Create and dispatch a change event
//       const changeEvent = new Event('change', { bubbles: true });
//       hiddenSelect.dispatchEvent(changeEvent);
//     }
//   }

//   document.addEventListener('DOMContentLoaded', () => {
//     var lastPurchaseType = ''
//     const productForms =
//       document.querySelectorAll('form[action^="/cart"]:not([id*="instal"])') ||
//       []

//     productForms.forEach(productForm => {
//       const productFormId = productForm.getAttribute('id')
//       const variantIdInput = productForm.querySelector('[name="id"]')
//       const sellingPlans =
//         productForm.querySelectorAll('[name="selling_plan"]') || []
//       const variants = productForm.querySelectorAll('[id^="subscription-variant--"]')
//       const parents = Array.from(variants).map(variant => variant.parentElement)

//       // Auto-select subscription option and first frequency
//       variants.forEach(wrapper => {
//         if (wrapper.className.indexOf('subscription-variant--active') !== -1) {
//           // Delay the auto-selection slightly to ensure DOM is ready
//           setTimeout(() => {
//             const subscriptionHeader = wrapper.querySelector('.subscription-option-header input[type="radio"]');
//             const frequencyDropdown = wrapper.querySelector('.frequency-dropdown');
            
//             if (subscriptionHeader) {
//               // Click the subscription radio button
//               subscriptionHeader.click();
              
//               // Select first option in frequency dropdown if exists
//               if (frequencyDropdown && frequencyDropdown.options.length > 0) {
//                 frequencyDropdown.selectedIndex = 0;
//                 const changeEvent = new Event('change', { bubbles: true });
//                 frequencyDropdown.dispatchEvent(changeEvent);
//               }
//             }
//           }, 100);
//         }
//       });

//       const updatePriceDisplay = (wrapper, productPrice) => {
//         console.log('updatePriceDisplay called with wrapper:', wrapper)
        
//         // Find the price container and its elements
//         const priceContainer = document.querySelector('[ref="priceContainer"]')
//         console.log('Price container found:', priceContainer)
        
//         let productPriceElement = null
//         let originalPriceElement = null
//         let comparePriceElement = null
        
//         if (priceContainer) {
//           productPriceElement = priceContainer.querySelector('.subscription-price') || priceContainer.querySelector('.price')
//           originalPriceElement = priceContainer.querySelector('.regular-price')
//           comparePriceElement = priceContainer.querySelector('.compare-at-price')
//         }

//         console.log('Price elements found:', {
//           productPriceElement,
//           originalPriceElement,
//           comparePriceElement
//         })

//         const sellingPlans = wrapper.querySelector('[name="selling_plan"]')
//         console.log('Selling plans select:', sellingPlans)
        
//         // Fix: Use selectedOptions or options[selectedIndex] instead of :checked
//         const sellingPlan = sellingPlans.selectedOptions[0] || sellingPlans.options[sellingPlans.selectedIndex]
//         console.log('Selected selling plan:', sellingPlan)

//         if (!sellingPlan) {
//           console.log('No selling plan selected, cannot update prices')
//           return
//         }

//         document.querySelectorAll('.afterpay_wrap.main').forEach(n=>{n.style.display = "none"})

//         const discountPercentage = sellingPlan.dataset.discount
//         const originalPrice = wrapper.dataset.price
//         const discountedPrice = sellingPlan.dataset.price
        
//         console.log('Price data:', {
//           discountPercentage,
//           originalPrice,
//           discountedPrice
//         })

//         const discountElement = wrapper.querySelector('.subscription-variant-discount')

//         // not displayed for subscription-only (e.g. 3-month packs)
//         if (discountElement) {
//           const discountPercentElement = discountElement.querySelector(
//             '.subscription-variant-discount-percentage'
//           )
//           const discountPriceElement = discountElement.querySelector(
//             '.subscription-variant-discount-price'
//           )

//           if (discountPercentage !== '0%') {
//             discountPercentElement.textContent = discountPercentage
//             discountPriceElement.textContent = discountedPrice
//             discountElement.style.display = ''
//           } else {
//             discountElement.style.display = 'none'
//           }
//         }

//         // Update the subscription widget's internal price displays
//         const subscriptionPriceElement = wrapper.querySelector('[data-widget-price-sub-price]')
//         const onetimePriceElement = wrapper.querySelector('[data-widget-price-onetime]')
//         const subCompareElement = wrapper.querySelector('[data-widget-price-sub-compare]')
        
//         console.log('Subscription widget internal price elements:', {
//           subscriptionPriceElement,
//           onetimePriceElement,
//           subCompareElement
//         })

//         if (subscriptionPriceElement) {
//           console.log('Updating subscription price element to:', discountedPrice)
//           subscriptionPriceElement.textContent = discountedPrice
//         }

//         if (onetimePriceElement) {
//           console.log('Updating onetime price element to:', originalPrice)
//           onetimePriceElement.textContent = originalPrice
//         }

//         if (subCompareElement) {
//           console.log('Updating subscription compare price to:', originalPrice)
//           subCompareElement.textContent = originalPrice
//         } 
//         // console.log("goodbye")
//         // console.log("discountedPrice",discountedPrice)
//         // const discountPriceSpan = document.querySelector('span#discount-price');
//         // const mainPriceSpan = document.querySelector('span#main-price');
//         // console.log(discountPrice);
//         // discountPriceSpan.style.display = 'block'
//         // discountPriceSpan.innerText = originalPrice
//         // mainPriceSpan.innerText

//         // ALWAYS show subscription pricing in main product area

//         // Calculate subscription price (20% discount)

//         const subscriptionDiscount = 20
//         const discountMultiplier = (100 - subscriptionDiscount) / 100
//         const originalPriceNum = parseFloat(originalPrice.replace(/[^0-9.]/g, ''))
//         const subscriptionPrice = originalPriceNum * discountMultiplier

//         // Format subscription price to match original format

//         const formattedSubscriptionPrice = new Intl.NumberFormat('en-US', {
//         style: 'currency',
//         currency: 'USD',
//         minimumFractionDigits: 2,
//         maximumFractionDigits: 2
//         }).format(subscriptionPrice)

//         if (productPriceElement) {
//           console.log('ALWAYS showing subscription price:', formattedSubscriptionPrice)
//           productPriceElement.textContent = formattedSubscriptionPrice
//         } else {
//           console.log('productPriceElement not found!')
//         }

//         if (originalPriceElement) {
//           console.log('ALWAYS showing original price as strikethrough:', originalPrice);
//           originalPriceElement.textContent = originalPrice;
//           originalPriceElement.style.display = ''
//           originalPriceElement.style.textDecoration = 'line-through'
//           originalPriceElement.style.color = 'rgba(24, 24, 24, 0.65)'
//         } else {
//           console.log('originalPriceElement not found!')
//         }
        
//         console.log('updatePriceDisplay completed')
//       }
//       const resetPriceDisplay = wrapper => {
//         console.log('resetPriceDisplay called with wrapper:', wrapper)
        
//         // Find the price container and its elements
//         const priceContainer = document.querySelector('[ref="priceContainer"]')
//         console.log('Price container found:', priceContainer)
        
//         let productPriceElement = null
//         let originalPriceElement = null
        
//         if (priceContainer) {
//           productPriceElement = priceContainer.querySelector('.subscription-price') || priceContainer.querySelector('.price')
//           originalPriceElement = priceContainer.querySelector('.regular-price')
//         }

//         // console.log("originalPriceElement",originalPriceElement)
//         // console.log("productPriceElement",productPriceElement)

//         // document.querySelector('.afterpay_wrap.main').style.display = "block";
//         document.querySelectorAll('.afterpay_wrap.main').forEach(n=>{n.style.display = "block"})

//         if (wrapper) {
//           const originalPrice = wrapper.dataset.price
//           const productTypes = wrapper.querySelectorAll('input[name="purchase_type"]');
//           if (productTypes.length <= 1) return;
//           // ALWAYS show subscription pricing in main product area
//           // Calculate subscription price (20% discount)
//           const subscriptionDiscount = 20
//           const discountMultiplier = (100 - subscriptionDiscount) / 100
//           const originalPriceNum = parseFloat(originalPrice.replace(/[^0-9.]/g, ''))
//           const subscriptionPrice = originalPriceNum * discountMultiplier

//           // Format subscription price to match original format
//           const formattedSubscriptionPrice = new Intl.NumberFormat('en-US', {
//           style: 'currency',
//           currency: 'USD',
//           minimumFractionDigits: 2,
//           maximumFractionDigits: 2
//           }).format(subscriptionPrice)
//           console.log("ALWAYS showing subscription price in reset:", formattedSubscriptionPrice);

//           if (productPriceElement) {
//             productPriceElement.textContent = formattedSubscriptionPrice
//           }
//           if (originalPriceElement) {
//             originalPriceElement.textContent = originalPrice
//             originalPriceElement.style.display = ''
//             originalPriceElement.style.textDecoration = 'line-through'
//             originalPriceElement.style.color = 'rgba(24, 24, 24, 0.65)'
//           }
//         }

//         // Note: originalPriceElement styling is handled above in the wrapper condition
//       }

//       const updateButtonPrice = (wrapper, isSubscription) => {
//         const buttonPriceElement = productForm.querySelector('[ref="buttonPrice"]')
//         if (!buttonPriceElement) return

//         const variantId = wrapper.dataset.variantId
//         if (!variantId) return

//         // Get the current variant price from the wrapper's data-price attribute
//         const priceText = wrapper.dataset.price || '$0.00'
//         const oneTimePrice = parseFloat(priceText.replace(/[^0-9.]/g, ''))
        
//                   let currentPrice = oneTimePrice
        
//         if (isSubscription) {
//           // Calculate subscription price with discount
//           const subscriptionDiscount = 20 // Default 20% discount
//           const discountMultiplier = (100 - subscriptionDiscount) / 100
//           const subscriptionPrice = oneTimePrice * discountMultiplier
//           currentPrice = subscriptionPrice
          
//           // Format the price
//           const formattedPrice = subscriptionPrice.toFixed(2)
//           buttonPriceElement.innerHTML = `• $${formattedPrice}`
//           // Update main price container to show subscription pricing
//           updateMainPriceContainer(subscriptionPrice, oneTimePrice, true)
//         } else {
//           // Show one-time price
//           const formattedPrice = oneTimePrice.toFixed(2)
//           buttonPriceElement.innerHTML = `• $${formattedPrice}`
          
//           // Update main price container to show one-time pricing
//           updateMainPriceContainer(oneTimePrice, oneTimePrice, false)
//         }
        
//         // Update Afterpay installments
//         updateAfterpayInstallments(currentPrice)
//       }

//       const updateAfterpayInstallments = (price) => {
//         const afterpayElement = document.getElementById('afterpay_instalments')
//         if (!afterpayElement) return

//         // Calculate installment amount (price divided by 4)
//         const installmentAmount = price / 4
        
//         // Format as currency
//         const formattedInstallment = new Intl.NumberFormat('en-US', {
//           style: 'currency',
//           currency: 'USD',
//           minimumFractionDigits: 2,
//           maximumFractionDigits: 2
//         }).format(installmentAmount)

//         afterpayElement.textContent = formattedInstallment
//       }

//       const syncToStickyBar = (isSubscription) => {
//         const stickyBar = document.querySelector('[data-sticky-add-to-cart]')
//         if (!stickyBar) return
        
//         const stickyOneTimeRadio = stickyBar.querySelector('input[name="sticky_purchase_type"][value="onetime"]')
//         const stickySubscriptionRadio = stickyBar.querySelector('input[name="sticky_purchase_type"][value="subscription"]')
        
//         if (isSubscription && stickySubscriptionRadio) {
//           stickySubscriptionRadio.checked = true
//           stickySubscriptionRadio.dispatchEvent(new Event('change', { bubbles: true }))
//         } else if (!isSubscription && stickyOneTimeRadio) {
//           stickyOneTimeRadio.checked = true
//           stickyOneTimeRadio.dispatchEvent(new Event('change', { bubbles: true }))
//         }
//       }

//       const updateMainPriceContainer = (displayPrice, originalPrice, isSubscription) => {
//         const priceContainer = document.querySelector('[ref="priceContainer"]')
//         if (!priceContainer) return

//         const subscriptionPriceElement = priceContainer.querySelector('.subscription-price')
//         const regularPriceElement = priceContainer.querySelector('.regular-price')
//         const subscriptionBadge = priceContainer.querySelector('.subscription-badge')
        
//         if (!subscriptionPriceElement || !regularPriceElement) return

//         // Format prices as currency
//         const formatPrice = (price) => {
//           return new Intl.NumberFormat('en-US', {
//             style: 'currency',
//             currency: 'USD',
//             minimumFractionDigits: 2,
//             maximumFractionDigits: 2
//           }).format(price)
//         }

//         // ALWAYS show subscription pricing in main product area
//         // Calculate subscription price (20% discount)
//         const subscriptionDiscount = 20
//         const discountMultiplier = (100 - subscriptionDiscount) / 100
//         const subscriptionPrice = originalPrice * discountMultiplier
//         // Always show subscription price as main price, regular price as crossed out
//         subscriptionPriceElement.textContent = formatPrice(subscriptionPrice)
        
//         // Always ensure subscription styling
//         subscriptionPriceElement.style.color = '#181818'
//         subscriptionPriceElement.style.textDecoration = 'none'
//         regularPriceElement.style.color = 'rgba(24, 24, 24, 0.65)'
//         regularPriceElement.style.textDecoration = 'line-through'
//         regularPriceElement.style.display = 'block'
        
//         // Show subscription badge if it exists
//         if (subscriptionBadge) {
//           subscriptionBadge.style.display = ''
//         }

//       }

//       sellingPlans.forEach(el => el.setAttribute('form', productFormId))

//       variants.forEach(wrapper => {
//         const purchaseTypes = wrapper.querySelectorAll(
//           'input[name="purchase_type"]'
//         )
//         purchaseTypes.forEach(purchaseType => {
//           purchaseType.addEventListener('click', e => {
//             // switch toggle
//             productForm.querySelectorAll('.rc_block__type').forEach(el => {
//               // override theme js
//               el.style.display = ''
//               el.classList.remove('rc_block__type--active')
//             })

//             const purchaseType = e.target
//             const sellingPlans = wrapper.querySelector('[name="selling_plan"]')
//             const block = purchaseType.closest('.rc_block__type')

//             // handle subscription option not output
//             block && block.classList.add('rc_block__type--active')

//             lastPurchaseType = purchaseType.value
//             const purchaseTypes = wrapper.querySelectorAll('input[name="purchase_type"]')

//             if (lastPurchaseType === 'autodeliver' && purchaseTypes.length > 1) {
//               sellingPlans.disabled = false
//               // console.log("=>updatePriceDisplay")
//               // console.log(wrapper)
//               // This is all handled in theme.js now
//               // updatePriceDisplay(wrapper)
//               updateButtonPrice(wrapper, true) // Update button to show subscription price
//               syncToStickyBar(true) // Sync to sticky bar
//             } else {
//               sellingPlans.disabled = true
//               // console.log("=>resetPriceDisplay")
//               // console.log(wrapper)
//               resetPriceDisplay(wrapper)
//               updateButtonPrice(wrapper, false) // Update button to show one-time price
//               syncToStickyBar(false)
//             }
//           })
//         })
//       })

//       // Listen for variant update events from the theme
//       const closestSection = productForm.closest('.shopify-section, dialog')
//       if (closestSection) {
//         console.log('Setting up variant update listener for:', productForm)
        
//         closestSection.addEventListener('variant:update', (event) => {
//           console.log('Variant update event received:', event.detail)
          
//           // Don't hide/show wrappers - just update prices directly
//           const newVariantPrice = event.detail.resource.price / 100
//           const formattedPrice = `$${newVariantPrice.toFixed(2)}`
          
//           console.log('New variant price:', formattedPrice)
          
//           // Update all subscription wrapper data-price attributes
//           variants.forEach(wrapper => {
//             console.log('Updating wrapper price data:', wrapper)
//             wrapper.dataset.price = formattedPrice
//           })
          
//           // Find the currently active wrapper (the one that's visible)
//           const activeWrapper = productForm.querySelector('.subscription-variant--active')
//           console.log('Active wrapper found:', activeWrapper)
          
//           if (activeWrapper) {
//             // Update selling plan data if available
//             const sellingPlansSelect = activeWrapper.querySelector('[name="selling_plan"]')
//             console.log('Selling plans select:', sellingPlansSelect)
//             console.log('Selling plan allocations:', event.detail.resource.selling_plan_allocations)
            
//             if (sellingPlansSelect && event.detail.resource.selling_plan_allocations) {
//               // Clear existing options
//               sellingPlansSelect.innerHTML = ''
              
//               // Add new selling plan options
//               event.detail.resource.selling_plan_allocations.forEach(allocation => {
//                 console.log('Processing allocation:', allocation)
                
//                 const option = document.createElement('option')
//                 option.value = allocation.selling_plan_id
//                 option.dataset.price = `$${(allocation.price / 100).toFixed(2)}`
                
//                 // Safely get discount percentage from price_adjustments
//                 let discountPercentage = '0%'
//                 if (allocation.price_adjustments && 
//                     allocation.price_adjustments.length > 0 &&
//                     allocation.price_adjustments[0]) {
//                   discountPercentage = `${allocation.price_adjustments[0].value || 0}%`
//                 }
//                 option.dataset.discount = discountPercentage
                
//                 // Use a default name since the selling plan name might not be directly available
//                 option.textContent = `Subscription Plan ${allocation.selling_plan_id}`
//                 sellingPlansSelect.appendChild(option)
//                 console.log('Added selling plan option:', allocation.selling_plan_id, 'with discount:', discountPercentage)
//               })
              
//               // Select the first option if available
//               if (sellingPlansSelect.options.length > 0) {
//                 sellingPlansSelect.selectedIndex = 0
                
//                 // Trigger change event to update hidden selling plan select
//                 const changeEvent = new Event('change', { bubbles: true });
//                 sellingPlansSelect.dispatchEvent(changeEvent);
//               }
              
//               console.log('Updated selling plan options')
//             }

//             // Check what purchase type is currently selected
//             const currentPurchaseType = activeWrapper.querySelector('input[name="purchase_type"]:checked')
//             const purchaseTypes = activeWrapper.querySelectorAll('input[name="purchase_type"]')
//             console.log('Current purchase type:', currentPurchaseType?.value)
            
//             if (currentPurchaseType && currentPurchaseType.value === 'autodeliver' && purchaseTypes.length > 1) {
//               // Update subscription pricing
//               console.log('Updating subscription pricing')
//               updatePriceDisplay(activeWrapper)
//               updateButtonPrice(activeWrapper, true)
//             } else {
//               // Update one-time pricing
//               console.log('Updating one-time pricing')
//               resetPriceDisplay(activeWrapper)
//               updateButtonPrice(activeWrapper, false)
//             }
//           } else {
//             console.log('No active subscription wrapper found - updating one-time pricing directly')
//             // No active subscription wrapper - update one-time pricing directly
//             const buttonPriceElement = productForm.querySelector('[ref="buttonPrice"]')
//             if (buttonPriceElement) {
//               buttonPriceElement.innerHTML = `• ${formattedPrice}`
//               updateAfterpayInstallments(newVariantPrice)
//               updateMainPriceContainer(newVariantPrice, newVariantPrice, false)
//             }
//           }
//         })
//       } else {
//         console.log('No closest section found for:', productForm)
//       }

//       variants.forEach(wrapper => {
//         if (wrapper.className.indexOf('subscription-variant--active') === -1) {
//           wrapper.remove()
//         } else if (wrapper.dataset.subscriptionOnly === 'true') {
//           const purchaseType = wrapper.querySelector(
//             'input[name="purchase_type"].rc_radio__autodeliver'
//           )
//           // console.log("purchaseType",purchaseType)
//           // trigger theme js things
//           purchaseType.click()

//           setTimeout(() => {
//             // again for good measure
//             purchaseType.click()
//           }, 500)
//         }
//       })
//     })
//   })

//   // Global function for deselectSubscription onclick handler
//   window.deselectSubscription = function(event) {
//     // This function is called when one-time purchase option is clicked
//     // The actual logic is handled by the radio button event listeners above
//     // This is just to prevent the error since it's referenced in the HTML
//   }
// })()
/* eslint func-names: off */


;(function () {
    if (window.subscriptionWidgetInitialized) {
      /* eslint no-console: off */
      console.log('Subscription widget already initialized')
  
      return
    }
  
    window.subscriptionWidgetInitialized = true
    
    window.handleFrequencyChange = function(event) {
      const selectedOption = event.target.selectedOptions[0];
      const sellingPlanId = selectedOption.value;
      const variant = event.target.closest('[id^="subscription-variant--"]');
      
      // Update the hidden selling plan select
      const hiddenSelect = variant.querySelector('select[name="selling_plan"]');
      if (hiddenSelect) {
        hiddenSelect.value = sellingPlanId;
        
        // Create and dispatch a change event
        const changeEvent = new Event('change', { bubbles: true });
        hiddenSelect.dispatchEvent(changeEvent);
      }
    }

    document.addEventListener('DOMContentLoaded', () => {
      var lastPurchaseType = ''
      const productForms =
        document.querySelectorAll('form[action^="/cart"]:not([id*="instal"])') ||
        []
  
      productForms.forEach(productForm => {
        const productFormId = productForm.getAttribute('id')
        const variantIdInput = productForm.querySelector('[name="id"]')
        const sellingPlans =
          productForm.querySelectorAll('[name="selling_plan"]') || []
        const variants = productForm.querySelectorAll('[id^="subscription-variant--"]')
        const parents = Array.from(variants).map(variant => variant.parentElement)

        // Subscription-only packs have a single autodeliver radio. Do not treat
        // that as OTP just because purchaseTypes.length is 1.
        const isSubscriptionPurchase = (wrapper, purchaseValue) => {
          if (wrapper.dataset.subscriptionOnly === 'true') {
            return true
          }

          return purchaseValue === 'autodeliver'
        }

        // Auto-select subscription option and first frequency
        variants.forEach(wrapper => {
          if (wrapper.className.indexOf('subscription-variant--active') !== -1) {
            // Delay the auto-selection slightly to ensure DOM is ready
            setTimeout(() => {
              if (!wrapper.isConnected) return
              const subscriptionHeader = wrapper.querySelector('.subscription-option-header input[type="radio"]');
              const frequencyDropdown = wrapper.querySelector('.frequency-dropdown');
              
              if (subscriptionHeader) {
                // Click the subscription radio button
                subscriptionHeader.click();
                
                // Select first option in frequency dropdown if exists
                if (frequencyDropdown && frequencyDropdown.options.length > 0) {
                  frequencyDropdown.selectedIndex = 0;
                  const changeEvent = new Event('change', { bubbles: true });
                  frequencyDropdown.dispatchEvent(changeEvent);
                }
              } else {
                // OTP-only active variant (e.g. With Caddy) — show full OTP, not subscription
                updateButtonPrice(wrapper, false)
                syncToStickyBar(false)
              }
            }, 100);
          }
        });
  
        const updatePriceDisplay = (wrapper, productPrice, freshForm) => {
          // Use fresh form reference if provided, otherwise fall back to old reference
          const formToUse = freshForm || productForm
          
          // The subscription widget has its OWN price elements inside the wrapper
          // Use widget-specific selectors, not the main product price selectors
          const productPriceElement = wrapper.querySelector('[data-widget-price-sub-price]')
          const originalPriceElement = wrapper.querySelector('[data-widget-price-sub-compare]')
          const comparePriceElement = document.querySelector('[data-compare-price-main]')
  
          const sellingPlans = wrapper.querySelector('[name="selling_plan"]')
          if (!sellingPlans) {
            // console.log('No selling plans found in wrapper - skipping price update')
            return
          }
          
          const sellingPlan = sellingPlans.querySelector('option:checked')
          if (!sellingPlan) {
            // console.log('No checked selling plan found - skipping price update')
            return
          }
          
          document.querySelectorAll('.afterpay_wrap.main').forEach(n=>{n.style.display = "none"})
          const discountPercentage =
            wrapper.dataset.subscriptionDiscount > 0
              ? `${wrapper.dataset.subscriptionDiscount}%`
              : sellingPlan.dataset.discount
          const formatCents = (cents) => {
            const parsed = parseInt(cents, 10)
            if (isNaN(parsed) || parsed <= 0) return null
            return `$${(parsed / 100).toFixed(2)}`
          }
          // Prefer Liquid-stamped cents so compare-price-new-logic stays on
          // compare-at ($207 → $148.83) instead of OTP ($186 → $133.73).
          const originalPrice =
            formatCents(wrapper.dataset.compareCents) || wrapper.dataset.price
          const discountedPrice =
            formatCents(wrapper.dataset.subscriptionCents) || sellingPlan.dataset.price

          // Keep the subscribe label / buybox SAVE badge in sync with metafield %.
          // Label copy is localized in Liquid and stamped on the wrapper; `[percent]`
          // in the savings template is filled in here.
          const discountPctNumber = String(discountPercentage || '').replace('%', '').trim()
          const labelTextSpan = wrapper.querySelector('.rc_label__autodeliver > span:not(.savings)')
          const discountBadge = wrapper.querySelector('.discount-badge')
          const buyboxLabel = wrapper.querySelector('.option-label.subscription-label')
          const {
            labelSubscribe = '',
            labelSubscribeWithSavings = '',
            labelSavePercent = '',
          } = wrapper.dataset
          const escapeRegExp = (text) => text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
          const savePercentPattern = labelSavePercent
            ? new RegExp(`^${escapeRegExp(labelSavePercent).replace('\\[percent\\]', '\\d+(?:\\.\\d+)?\\s*')}$`, 'i')
            : null
          // Only default labels are rewritten; a merchant's custom label (e.g. `sub-save`) is left alone.
          const isDefaultLabel = (text) =>
            text === labelSubscribe ||
            text === labelSubscribeWithSavings ||
            Boolean(savePercentPattern && savePercentPattern.test(text))

          if (discountPctNumber && discountPctNumber !== '0') {
            wrapper.dataset.subscriptionDiscount = discountPctNumber
            if (labelTextSpan && labelSavePercent && isDefaultLabel(labelTextSpan.textContent.trim())) {
              labelTextSpan.textContent = labelSavePercent.replace('[percent]', Math.round(discountPctNumber))
            }
            if (discountBadge) {
              if (buyboxLabel && labelSubscribeWithSavings && isDefaultLabel(buyboxLabel.textContent.trim())) {
                buyboxLabel.textContent = labelSubscribeWithSavings
              }
              discountBadge.textContent = `SAVE ${Math.round(discountPctNumber)}%`
              discountBadge.style.display = 'inline-flex'
            } else if (buyboxLabel && labelSubscribe) {
              buyboxLabel.textContent = labelSubscribe
            }
          } else {
            wrapper.dataset.subscriptionDiscount = '0'
            if (labelTextSpan && labelSubscribe) {
              labelTextSpan.textContent = labelSubscribe
            }
            if (buyboxLabel && labelSubscribe) {
              buyboxLabel.textContent = labelSubscribe
            }
            if (discountBadge) {
              discountBadge.style.display = 'none'
            }
          }
          
          if (!productPriceElement) {
            // console.log('Product price element not found - skipping price update')
            return
          }
  
          const discountElement = wrapper.querySelector('.subscription-variant-discount')
  
          // not displayed for subscription-only (e.g. 3-month packs)
          if (discountElement) {
            const discountPercentElement = discountElement.querySelector(
              '.subscription-variant-discount-percentage'
            )
            const discountPriceElement = discountElement.querySelector(
              '.subscription-variant-discount-price'
            )
  
            if (discountPercentage !== '0%') {
              discountPercentElement.textContent = discountPercentage
              discountPriceElement.textContent = discountedPrice
              discountElement.style.display = ''
            } else {
              discountElement.style.display = 'none'
            }
          } 
          // console.log("goodbye")
          // console.log("discountedPrice",discountedPrice)
          // const discountPriceSpan = document.querySelector('span#discount-price');
          // const mainPriceSpan = document.querySelector('span#main-price');
          // console.log(discountPrice);
          // discountPriceSpan.style.display = 'block'
          // discountPriceSpan.innerText = originalPrice
          // mainPriceSpan.innerText
  
          productPriceElement.textContent = discountedPrice
  
          if (originalPriceElement) {
            if (
              discountedPrice === originalPrice ||
              (comparePriceElement && comparePriceElement.textContent.trim() !== '')
            ) {
              originalPriceElement.textContent = ''
              originalPriceElement.style.display = 'none'
            } else {
              originalPriceElement.textContent = originalPrice.split(".")[0]
              originalPriceElement.style.display = ''
            }
          }
          
          // Notify sticky cart that prices have been updated
          document.dispatchEvent(new CustomEvent('subscription-price-updated'));
        }
        const resetPriceDisplay = (wrapper, freshForm) => {
          // Use fresh form reference if provided, otherwise fall back to old reference
          const formToUse = freshForm || productForm
          
          // The subscription widget has its OWN one-time price element inside the wrapper
          // Use widget-specific selector for one-time purchase
          const productPriceElement = wrapper.querySelector('[data-widget-price-onetime]')
          const originalPriceElement = null // One-time doesn't have a compare price in the widget
  
          // console.log("originalPriceElement",originalPriceElement)
          // console.log("productPriceElement",productPriceElement)
  
          // document.querySelector('.afterpay_wrap.main').style.display = "block";
          document.querySelectorAll('.afterpay_wrap.main').forEach(n=>{n.style.display = "block"})
  
          if (wrapper) {
            const originalPrice = wrapper.dataset.price
            // console.log('Resetting to original price:', originalPrice)
            
            if (productPriceElement) {
              productPriceElement.textContent = originalPrice
            }
            
            // Reset regular price element properly
            if (originalPriceElement) {
              // For one-time purchase, check if there's a compare-at price
              if (comparePriceElement && comparePriceElement.textContent && comparePriceElement.textContent.trim() !== '') {
                // There's a compare-at price, so show the regular price as struck through
                originalPriceElement.textContent = comparePriceElement.textContent
                originalPriceElement.style.removeProperty('display')
                originalPriceElement.style.display = ''
                // console.log('One-time mode - showing regular price element with compare-at price')
              } else {
                // No compare-at price, hide the regular price element
                originalPriceElement.textContent = ''
                originalPriceElement.style.display = 'none'
                // console.log('One-time mode - hiding regular price element - no compare-at price')
              }
              // console.log('Reset originalPriceElement display style:', originalPriceElement.style.display)
            }
          }
          
          // console.log('resetPriceDisplay completed')
        }

        const updateButtonPrice = (wrapper, isSubscription) => {
          const buttonPriceElement = productForm.querySelector('[ref="buttonPrice"]')
          // debugger;
          if (!buttonPriceElement) return

          // Ensure dynamic price updates are announced to screen readers
          if (!buttonPriceElement.hasAttribute('aria-live')) {
            buttonPriceElement.setAttribute('aria-live', 'polite')
            buttonPriceElement.setAttribute('aria-atomic', 'true')
          }

          const variantId = wrapper.dataset.variantId
          if (!variantId) return

          // Get the current variant price from the wrapper's data-price attribute
          const priceText = wrapper.dataset.price || '$0.00'
          const oneTimePrice = parseFloat(priceText.replace(/[^0-9.]/g, ''))
          
          let currentPrice = oneTimePrice
          
          if (isSubscription) {
            // Get the selected selling plan option's price (already set correctly by Liquid)
            const sellingPlansSelect = wrapper.querySelector('select[name="selling_plan"]')
            let subscriptionPrice = oneTimePrice
            
            if (sellingPlansSelect) {
              const selectedOption = sellingPlansSelect.options[sellingPlansSelect.selectedIndex]
              if (selectedOption && selectedOption.dataset.price) {
                // Use the price from the option (already calculated correctly in Liquid for sub-0/sub-save)
                const sellingPlanPriceText = selectedOption.dataset.price
                subscriptionPrice = parseFloat(sellingPlanPriceText.replace(/[^0-9.]/g, ''))
              }
            }
            
            currentPrice = subscriptionPrice
            
            // Format the price
            const formattedPrice = subscriptionPrice.toFixed(2)
            const buttonPriceText = `• $${formattedPrice}`
            
            // Store correct button price for protection
            window._priceProtection.correctButtonPrice = buttonPriceText
            
            buttonPriceElement.textContent = buttonPriceText
            // Update main price container to show subscription pricing
            updateMainPriceContainer(subscriptionPrice, oneTimePrice, true)
          } else {
            // Check for OTP specific discount from widget
            let displayPrice = oneTimePrice;
            
            // Look for OTP block and its sub-price
            const otpBlock = wrapper.querySelector('.rc_block__type__onetime');
            if (otpBlock) {
               // Try standard sub-price attribute first (user specified)
               let otpSubPriceElement = otpBlock.querySelector('[data-widget-price-sub-price]');
               
               // Fallback: Check if the regular onetime price element has been updated to a lower price
               if (!otpSubPriceElement) {
                 otpSubPriceElement = otpBlock.querySelector('[data-widget-price-onetime]');
               }
               
               if (otpSubPriceElement && otpSubPriceElement.textContent.trim()) {
                  const otpPriceText = otpSubPriceElement.textContent.trim();
                  // Handle potential multiple prices (e.g. "$55.00 $44.00") by taking the last one or checking structure
                  // If text contains multiple prices, we want the lowest one (discounted)
                  const matches = otpPriceText.match(/[0-9]+\.[0-9]+/g);
                  if (matches && matches.length > 0) {
                    const prices = matches.map(p => parseFloat(p));
                    const minPrice = Math.min(...prices);
                    if (!isNaN(minPrice)) {
                       displayPrice = minPrice;
                    }
                  } else {
                    const otpPriceNum = parseFloat(otpPriceText.replace(/[^0-9.]/g, ''));
                    if (!isNaN(otpPriceNum)) {
                       displayPrice = otpPriceNum;
                    }
                  }
               }
            }

            // Format the price
            const formattedPrice = displayPrice.toFixed(2)
            const buttonText = `• $${formattedPrice}`
            
            // Set button protection
            window._priceProtection.correctButtonPrice = buttonText;
            
            buttonPriceElement.textContent = buttonText
            
            // Update main price container to show one-time pricing
            updateMainPriceContainer(displayPrice, oneTimePrice, false)
          }
          
          // Update Afterpay installments
          updateAfterpayInstallments(currentPrice)
        }

        const updateAfterpayInstallments = (price) => {
          const afterpayElement = document.getElementById('afterpay_instalments')
          if (!afterpayElement) return

          // Calculate installment amount (price divided by 4)
          const installmentAmount = price / 4
          
          // Format as currency
          const formattedInstallment = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }).format(installmentAmount)

          afterpayElement.textContent = formattedInstallment
        }

        const syncToStickyBar = (isSubscription) => {
          const stickyBar = document.querySelector('[data-sticky-add-to-cart]')
          if (!stickyBar) return
          
          const stickyOneTimeRadio = stickyBar.querySelector('input[name="sticky_purchase_type"][value="onetime"]')
          const stickySubscriptionRadio = stickyBar.querySelector('input[name="sticky_purchase_type"][value="subscription"]')
          
          if (isSubscription && stickySubscriptionRadio) {
            stickySubscriptionRadio.checked = true
            stickySubscriptionRadio.dispatchEvent(new Event('change', { bubbles: true }))
          } else if (!isSubscription && stickyOneTimeRadio) {
            stickyOneTimeRadio.checked = true
            stickyOneTimeRadio.dispatchEvent(new Event('change', { bubbles: true }))
          }
        }


        // Store correct prices on window object to persist across morphs
        if (!window._priceProtection) {
          window._priceProtection = {
            correctSubscriptionPrice: null,
            correctOTPPrice: null,
            correctButtonPrice: null,
            isSubscriptionMode: false
          }
        }
        
        // Install a global protector that FIXES wrong prices immediately
        const installGlobalPriceProtector = () => {
          const priceContainer = document.querySelector('[ref="priceContainer"]')
          if (!priceContainer) return
          
          const subscriptionPriceElement = priceContainer.querySelector('.subscription-price')
          if (!subscriptionPriceElement) return
          
          if (window._globalPriceProtector) {
            window._globalPriceProtector.disconnect()
          }
          
          window._globalPriceProtector = new MutationObserver((mutations) => {
            
            const activeWrapper =
              document.querySelector('.subscription-variant--active') ||
              document.querySelector('[id^="subscription-variant--"]:not([style*="display: none"])')
            const subscriptionRadio = activeWrapper?.querySelector(
              'input[name="purchase_type"][value="autodeliver"]:checked'
            )
            let correctPrice = null;

            if (subscriptionRadio) {
              if (window._priceProtection.correctSubscriptionPrice) {
                correctPrice = window._priceProtection.correctSubscriptionPrice;
              }
            } else {
              // OTP mode
              if (window._priceProtection.correctOTPPrice) {
                correctPrice = window._priceProtection.correctOTPPrice;
              }
            }
            
            if (!correctPrice) return;
            
            const currentPrice = subscriptionPriceElement.textContent
            
            if (currentPrice !== correctPrice) {
              subscriptionPriceElement.textContent = correctPrice
            }
          })
          
          window._globalPriceProtector.observe(subscriptionPriceElement, {
            childList: true,
            characterData: true,
            subtree: true
          })
        }
        
        // Install protector on page load
        installGlobalPriceProtector()
        
        // Also protect button price
        const installButtonPriceProtector = () => {
          const buttonPriceElement = productForm.querySelector('[ref="buttonPrice"]')
          if (!buttonPriceElement) return

          // Ensure dynamic price updates are announced to screen readers
          if (!buttonPriceElement.hasAttribute('aria-live')) {
            buttonPriceElement.setAttribute('aria-live', 'polite')
            buttonPriceElement.setAttribute('aria-atomic', 'true')
          }
 
          if (window._buttonPriceProtector) {
            window._buttonPriceProtector.disconnect()
          }
          
          window._buttonPriceProtector = new MutationObserver(() => {
            // Protect if we have a correctButtonPrice set.
            if (!window._priceProtection.correctButtonPrice) return
            
            const currentButtonPrice = buttonPriceElement.textContent
            if (currentButtonPrice !== window._priceProtection.correctButtonPrice) {
              buttonPriceElement.textContent = window._priceProtection.correctButtonPrice
            }
          })
          
          window._buttonPriceProtector.observe(buttonPriceElement, {
            childList: true,
            characterData: true,
            subtree: true
          })
        }
        
        installButtonPriceProtector()

        const updateMainPriceContainer = (displayPrice, originalPrice, isSubscription) => {
          const priceContainer = document.querySelector('[ref="priceContainer"]')
          if (!priceContainer) return

          const subscriptionPriceElement = priceContainer.querySelector('.subscription-price')
          const onetimePriceElement = priceContainer.querySelector('.regular-price[data-price-type="onetime"]')
          const compareAtPriceElement = priceContainer.querySelector('.regular-price[data-price-type="compare-at"]')
          const regularPriceElement = onetimePriceElement || priceContainer.querySelector('.regular-price')
          const subscriptionBadge = priceContainer.querySelector('.subscription-badge')
          const savingsElement = priceContainer.querySelector('[data-price-savings]')
          
          // Only subscription price is required - regular price may not exist for sub-save/sub-0 products
          if (!subscriptionPriceElement) return

          // `compare-price-new-logic` products strike their compare-at price, which Liquid
          // stamps on the element. The widget only knows the one-time price, so
          // without this it would overwrite the struck figure on every toggle.
          const struckOverride = regularPriceElement ? parseFloat(regularPriceElement.dataset.struckPrice) : NaN
          const struckPrice = Number.isNaN(struckOverride) ? Number(originalPrice) : struckOverride

          // Format prices as currency
          const formatPrice = (price) => {
            return new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: 'USD',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }).format(price)
          }

          if (isSubscription) {
            const formattedPrice = formatPrice(displayPrice)
            const hasDiscount = Number(displayPrice) < struckPrice
            
            // Store the correct price for the protector
            window._priceProtection.correctSubscriptionPrice = formattedPrice
            window._priceProtection.isSubscriptionMode = true
            
            // Show subscription price as main price; only strike OTP when there is a real save
            subscriptionPriceElement.textContent = formattedPrice
            
            if (regularPriceElement) {
              if (hasDiscount) {
                regularPriceElement.textContent = formatPrice(struckPrice)
                regularPriceElement.style.color = 'rgba(24, 24, 24, 0.65)'
                regularPriceElement.style.textDecoration = 'line-through'
                regularPriceElement.style.display = 'block'
              } else {
                regularPriceElement.textContent = ''
                regularPriceElement.style.textDecoration = 'none'
                regularPriceElement.style.display = 'none'
              }
            }

            if (compareAtPriceElement) {
              compareAtPriceElement.style.display = 'none'
            }
            
            // Ensure proper styling
            subscriptionPriceElement.style.color = '#181818'
            subscriptionPriceElement.style.textDecoration = 'none'
            
            if (subscriptionBadge) {
              subscriptionBadge.style.display = hasDiscount ? '' : 'none'
            }

            // Savings copy is rendered against the struck price, so it only holds
            // while there is one.
            if (savingsElement) {
              savingsElement.style.display = hasDiscount ? '' : 'none'
            }
          } else {
            // Clear protection mode for one-time purchase
            window._priceProtection.isSubscriptionMode = false
            window._priceProtection.correctSubscriptionPrice = null
            
            const formattedDisplayPrice = formatPrice(displayPrice);
            window._priceProtection.correctOTPPrice = formattedDisplayPrice;
            
            // Show one-time price as main price, hide subscription styling
            subscriptionPriceElement.textContent = formattedDisplayPrice
            
            // Re-install protector in case elements were replaced
            installGlobalPriceProtector();
            
            if (regularPriceElement) {
              if (!Number.isNaN(struckOverride) && struckOverride > Number(displayPrice)) {
                regularPriceElement.textContent = formatPrice(struckOverride)
                regularPriceElement.style.color = 'rgba(24, 24, 24, 0.65)'
                regularPriceElement.style.textDecoration = 'line-through'
                regularPriceElement.style.display = 'block'
              } else {
                regularPriceElement.textContent = ''
                regularPriceElement.style.textDecoration = 'none'
                regularPriceElement.style.display = 'none'
              }
            }

            if (compareAtPriceElement) {
              compareAtPriceElement.style.color = 'rgba(24, 24, 24, 0.65)'
              compareAtPriceElement.style.textDecoration = 'line-through'
              compareAtPriceElement.style.display = Number.isNaN(struckOverride) ? 'block' : 'none'
            }
            
            // Update styling for one-time purchase
            subscriptionPriceElement.style.color = '#181818'
            subscriptionPriceElement.style.textDecoration = 'none'
            
            // Hide subscription badge if it exists
            if (subscriptionBadge) {
              subscriptionBadge.style.display = 'none'
            }

            // The subscription saving no longer applies on one-time purchase.
            if (savingsElement) {
              savingsElement.style.display = 'none'
            }
          }
        }
  
        sellingPlans.forEach(el => el.setAttribute('form', productFormId))
  
        variants.forEach(wrapper => {
          const purchaseTypes = wrapper.querySelectorAll(
            'input[name="purchase_type"]'
          )
          purchaseTypes.forEach(purchaseType => {
            purchaseType.addEventListener('click', e => {
              // switch toggle
              productForm.querySelectorAll('.rc_block__type').forEach(el => {
                // override theme js
                el.style.display = ''
                el.classList.remove('rc_block__type--active')
              })
  
              const purchaseType = e.target
              const sellingPlans = wrapper.querySelector('[name="selling_plan"]')
              const block = purchaseType.closest('.rc_block__type')
  
              // handle subscription option not output
              block && block.classList.add('rc_block__type--active')
  
              lastPurchaseType = purchaseType.value
              const purchaseTypes = wrapper.querySelectorAll('input[name="purchase_type"]')
  
              if (isSubscriptionPurchase(wrapper, lastPurchaseType)) {
                sellingPlans.disabled = false
                updatePriceDisplay(wrapper)
                updateButtonPrice(wrapper, true)
                syncToStickyBar(true)
              } else {
                sellingPlans.disabled = true
                resetPriceDisplay(wrapper)
                updateButtonPrice(wrapper, false)
                syncToStickyBar(false)
              }
            })
          })
        })
  
        // Listen for variant update events from the theme
        const closestSection = productForm.closest('.shopify-section, dialog')
        if (closestSection) {
          // console.log('Setting up variant update listener for:', productForm)
          
          closestSection.addEventListener('variant:update', (event) => {
            // Don't hide/show wrappers - just update prices directly
            const newVariantPrice = event.detail.resource.price / 100
            const formattedPrice = `$${newVariantPrice.toFixed(2)}`
            
            // Update all subscription wrapper data-price attributes
            variants.forEach(wrapper => {
              wrapper.dataset.price = formattedPrice
            })
            
            // Use a small delay to allow DOM morph to complete before updating prices
            setTimeout(() => {
              const variantId = event.detail.resource.id
              
              // Re-query the productForm fresh since it might be replaced during morph
              const freshProductForm = closestSection.querySelector('form[action^="/cart"]:not([id*="instal"])')
              
              if (!freshProductForm) {
                // console.log('Product form not found after morph - cannot update prices')
                return
              }
              
              // Prefer the active / matching wrapper — never assume the first [id^=subscription-variant]
              let activeWrapper =
                freshProductForm.querySelector(`.subscription-variant--active`) ||
                freshProductForm.querySelector(`[id="subscription-variant--${variantId}"]`)
              
              // Fallback: Query all fresh and find visible one
              if (!activeWrapper) {
                const freshWrappers = freshProductForm.querySelectorAll('[id^="subscription-variant--"]')
                freshWrappers.forEach(wrapper => {
                  const computedStyle = window.getComputedStyle(wrapper)
                  if (computedStyle.display !== 'none') {
                    activeWrapper = wrapper
                  }
                })
              }
              
              // Last fallback: any subscription wrapper
              if (!activeWrapper) {
                activeWrapper = freshProductForm.querySelector('[id^="subscription-variant--"]')
              }
              
              const variantResource = event.detail.resource
              const fetchedHtml = event.detail.data ? event.detail.data.html : null
              let wasInserted = false
              
              if (activeWrapper && String(activeWrapper.dataset.variantId) !== String(variantId)) {
                activeWrapper = null
              }
              
              if (!activeWrapper && fetchedHtml) {
                const widgetContainer = freshProductForm.querySelector('.subscription-widget')
                const newWrapperSource = fetchedHtml.querySelector('#subscription-variant--' + variantId)
                
                if (widgetContainer && newWrapperSource) {
                  widgetContainer.querySelectorAll('[id^="subscription-variant--"]').forEach(w => w.remove())
                  
                  const clonedWrapper = newWrapperSource.cloneNode(true)
                  clonedWrapper.style.display = ''
                  clonedWrapper.style.position = 'relative'
                  clonedWrapper.classList.add('subscription-variant--active')
                  widgetContainer.appendChild(clonedWrapper)
                  
                  const freshFormId = freshProductForm.getAttribute('id')
                  clonedWrapper.querySelectorAll('[name="selling_plan"]').forEach(el => {
                    el.setAttribute('form', freshFormId)
                  })
                  
                  clonedWrapper.querySelectorAll('input[name="purchase_type"]').forEach(pt => {
                    pt.addEventListener('click', e => {
                      productForm.querySelectorAll('.rc_block__type').forEach(el => {
                        el.style.display = ''
                        el.classList.remove('rc_block__type--active')
                      })
                      
                      const clickedPt = e.target
                      const sp = clonedWrapper.querySelector('[name="selling_plan"]')
                      const block = clickedPt.closest('.rc_block__type')
                      block && block.classList.add('rc_block__type--active')
                      
                      lastPurchaseType = clickedPt.value
                      const allPts = clonedWrapper.querySelectorAll('input[name="purchase_type"]')
                      
                      if (isSubscriptionPurchase(clonedWrapper, lastPurchaseType)) {
                        sp.disabled = false
                        updatePriceDisplay(clonedWrapper)
                        updateButtonPrice(clonedWrapper, true)
                        syncToStickyBar(true)
                      } else {
                        sp.disabled = true
                        resetPriceDisplay(clonedWrapper)
                        updateButtonPrice(clonedWrapper, false)
                        syncToStickyBar(false)
                      }
                    })
                  })
                  
                  setTimeout(() => {
                    const subHeader = clonedWrapper.querySelector('.subscription-option-header input[type="radio"]')
                    if (subHeader) {
                      subHeader.click()
                      const fd = clonedWrapper.querySelector('.frequency-dropdown')
                      if (fd && fd.options && fd.options.length > 0) {
                        fd.selectedIndex = 0
                        fd.dispatchEvent(new Event('change', { bubbles: true }))
                      }
                    } else {
                      // OTP-only inserted wrapper (e.g. With Caddy)
                      updateButtonPrice(clonedWrapper, false)
                      syncToStickyBar(false)
                    }
                  }, 50)
                  
                  activeWrapper = clonedWrapper
                  wasInserted = true
                }
              }
              
              if (fetchedHtml) {
                const newPriceContainer = fetchedHtml.querySelector('product-price [ref="priceContainer"]')
                const currentPriceContainer = document.querySelector('[ref="priceContainer"]')
                if (newPriceContainer && currentPriceContainer) {
                  currentPriceContainer.replaceWith(newPriceContainer.cloneNode(true))
                  installGlobalPriceProtector()
                }
              }
              
              if (activeWrapper) {
                const sellingPlansSelect = activeWrapper.querySelector('[name="selling_plan"]')
                
                if (
                  !wasInserted &&
                  sellingPlansSelect &&
                  sellingPlansSelect.tagName === 'SELECT' &&
                  variantResource.selling_plan_allocations &&
                  variantResource.selling_plan_allocations.length > 0
                ) {
                  // Clear existing options
                  sellingPlansSelect.innerHTML = ''
                  
                  // Get product tag info to apply correct pricing
                  const productFormComponent = activeWrapper.closest('product-form-component')
                  const hasSubZero = productFormComponent?.dataset.hasSubZero === 'true'
                  
                  // Get the variant's regular price (without any discount)
                  const variantRegularPrice = variantResource.price

                  // Liquid already priced this variant, including `compare-price-new-logic`
                  // where the discount is taken off compare-at ($208 → $109.65), not the
                  // one-time price. Re-deriving from variant.price gave the header a
                  // subscription price that no longer matched its struck figure or savings.
                  const pricedWrapper =
                    (fetchedHtml && fetchedHtml.querySelector(`#subscription-variant--${variantId}`)) || activeWrapper
                  const liquidSubscriptionCents = parseInt(pricedWrapper.dataset.subscriptionCents, 10)
                  const metafieldDiscount = parseFloat(pricedWrapper.dataset.subscriptionDiscount) || null
                  activeWrapper.dataset.subscriptionCents = pricedWrapper.dataset.subscriptionCents || ''
                  activeWrapper.dataset.compareCents = pricedWrapper.dataset.compareCents || ''
                  activeWrapper.dataset.subscriptionDiscount = metafieldDiscount || '0'

                  variantResource.selling_plan_allocations.forEach(allocation => {
                    const option = document.createElement('option')
                    option.value = allocation.selling_plan_id

                    // Calculate correct price based on product tags and discount hierarchy
                    let calculatedPrice

                    if (hasSubZero || !metafieldDiscount) {
                      calculatedPrice = variantRegularPrice
                    } else if (liquidSubscriptionCents > 0) {
                      calculatedPrice = liquidSubscriptionCents
                    } else {
                      calculatedPrice = Math.round(variantRegularPrice * (100 - metafieldDiscount) / 100)
                    }

                    option.dataset.price = `$${(calculatedPrice / 100).toFixed(2)}`

                    let discountPercentage = '0%'
                    if (!hasSubZero && metafieldDiscount && metafieldDiscount > 0) {
                      discountPercentage = `${metafieldDiscount}%`
                    }
                    option.dataset.discount = discountPercentage
                    
                    // Use a default name since the selling plan name might not be directly available
                    option.textContent = `Subscription Plan ${allocation.selling_plan_id}`
                    sellingPlansSelect.appendChild(option)
                  })
                  
                  // Select the first option if available
                  if (sellingPlansSelect.options.length > 0) {
                    sellingPlansSelect.selectedIndex = 0
                    
                    // Trigger change event to update hidden selling plan select
                    const changeEvent = new Event('change', { bubbles: true });
                    sellingPlansSelect.dispatchEvent(changeEvent);
                  }
                }

                // Check what purchase type is currently selected
                const currentPurchaseType = activeWrapper.querySelector('input[name="purchase_type"]:checked')
                const purchaseTypes = activeWrapper.querySelectorAll('input[name="purchase_type"]')
                
                // ALWAYS update BOTH subscription AND one-time prices since both are visible
                // Update subscription prices (discounted + original)
                updatePriceDisplay(activeWrapper, null, freshProductForm)
                
                // Update one-time price
                resetPriceDisplay(activeWrapper, freshProductForm)
                
                // Update button price based on what's selected
                if (isSubscriptionPurchase(activeWrapper, currentPurchaseType && currentPurchaseType.value)) {
                  updateButtonPrice(activeWrapper, true)
                } else {
                  updateButtonPrice(activeWrapper, false)
                }
              } else {
                const buttonPriceElement = freshProductForm.querySelector('[ref="buttonPrice"]')
                if (buttonPriceElement) {
                  const priceText = `• ${formattedPrice}`
                  window._priceProtection.correctButtonPrice = priceText
                  buttonPriceElement.innerHTML = priceText
                  updateAfterpayInstallments(newVariantPrice)
                  updateMainPriceContainer(newVariantPrice, newVariantPrice, false)
                }
              }
              
              if (fetchedHtml) {
                const stickyBar = document.querySelector('[data-sticky-add-to-cart]')
                if (stickyBar) {
                  const newStickyBar = fetchedHtml.querySelector('[data-sticky-add-to-cart]')
                  if (newStickyBar) {
                    const currentSub = stickyBar.querySelector('.sticky-add-to-cart__subscription')
                    const newSub = newStickyBar.querySelector('.sticky-add-to-cart__subscription')
                    
                    if (currentSub && newSub) {
                      currentSub.replaceWith(newSub.cloneNode(true))
                    } else if (currentSub && !newSub) {
                      currentSub.remove()
                    } else if (!currentSub && newSub) {
                      const productContainer = stickyBar.querySelector('.sticky-add-to-cart__product-container')
                      if (productContainer) {
                        productContainer.appendChild(newSub.cloneNode(true))
                      }
                    }
                    
                    if (newStickyBar.hasAttribute('data-no-subscription')) {
                      stickyBar.setAttribute('data-no-subscription', '')
                    } else {
                      stickyBar.removeAttribute('data-no-subscription')
                    }
                    
                    if (typeof stickyBar.setupSubscriptionListeners === 'function') {
                      stickyBar.setupSubscriptionListeners()
                      stickyBar.setupMainSubscriptionListeners()
                    }
                  }
                }
              }
            }, 150) // Wait 150ms for DOM to settle after morph
          })
        } else {
          console.log('No closest section found for:', productForm)
        }
  
        variants.forEach(wrapper => {
          if (wrapper.className.indexOf('subscription-variant--active') === -1) {
            wrapper.remove()
          } else if (wrapper.dataset.subscriptionOnly === 'true') {
            const purchaseType = wrapper.querySelector(
              'input[name="purchase_type"].rc_radio__autodeliver'
            )
            // console.log("purchaseType",purchaseType)
            // trigger theme js things
            purchaseType.click()
  
            setTimeout(() => {
              // again for good measure
              purchaseType.click()
            }, 500)
          }
        })
      })
    })
  })()
